module.exports = __webpack_public_path__ + "img/v5.ece81661.png";